export const SPECIAL_SEAT_TYPE = Object.freeze({
  freeSpace: 'フリースペース',
  prioritySeat: '優先席'
});

export const tx1000or2000CarInformation = {
    informations: [
        {
            number: 6,
            specialSeats: [
                null,
                null,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [],
            prioritySeatDoorNumbers: [1]
        },
        {
            number: 5,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [1],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 4,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 3,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 2,
            specialSeats: [
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [4],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 1,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                null,
                null
            ],
            freeSpaceDoorNumbers: [],
            prioritySeatDoorNumbers: [4]
        }
    ]
};

export const tx3000CarInformation = {
    informations: [
        {
            number: 6,
            specialSeats: [
                null,
                null,
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [1],
            prioritySeatDoorNumbers: [1]
        },
        {
            number: 5,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [1],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 4,
            specialSeats: [
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [1],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 3,
            specialSeats: [
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [4],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 2,
            specialSeats: [
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat,
                SPECIAL_SEAT_TYPE.prioritySeat
            ],
            freeSpaceDoorNumbers: [4],
            prioritySeatDoorNumbers: [1, 4]
        },
        {
            number: 1,
            specialSeats: [
                SPECIAL_SEAT_TYPE.freeSpace,
                SPECIAL_SEAT_TYPE.prioritySeat,
                null,
                null
            ],
            freeSpaceDoorNumbers: [4],
            prioritySeatDoorNumbers: [4]
        }
    ]
};